import * as YupDefault from 'yup';

/**
 * Re-export the Yup object schema from the yup module.
 */
export const Yup = YupDefault;

/**
 * Extends the Yup object schema to include a custom method to compare properties in a collection.
 */
declare module 'yup' {
    interface ObjectSchema<TShape> {
        comparePropertiesInCollection(
            message: string,
            comparator: (value: TShape, item: TShape) => boolean
        ): this;
    }
}

/**
 * Adds a custom Yup schema validator to compare the value of a property
 * in a collection against another property in the same collection.
 *
 * @param message - The error message to display if validation fails
 * @param comparator - The comparison function to validate items in the collection
 */
function comparePropertiesInCollection<TShape>(
    message: string,
    comparator: (value: TShape, item: TShape) => boolean
) {
    return this.test(
        'compare-properties-in-collection',
        message,
        (value, context) => {
            const parentCollection = context.parent;
            const isValid: boolean = parentCollection.some((item) =>
                comparator(value, item)
            );

            return !isValid;
        }
    );
}

Yup.addMethod(
    Yup.object,
    'comparePropertiesInCollection',
    comparePropertiesInCollection
);
